import type { AppWidgetData } from '@ecomm/scout'

import {
  useAffirmBannerQuery,
  useAppWidgetQuery,
  useCameraBannerAssetQuery,
  useExpertReviewsQuery,
  useExpertSectionAssetQuery,
  useGuaranteeAssetQuery,
  useGuaranteeCopyQuery,
  useQuoteWizardAssetQuery,
  useVideoButtonAssetQuery
} from './queries'
export const useStaticQueries = () => {
  const { expertReviews: expertReviewsData } = useExpertReviewsQuery()
  const videoButtonAssetData = useVideoButtonAssetQuery()
  const expertSectionAssetData = useExpertSectionAssetQuery()
  const affirmBannerData = useAffirmBannerQuery()
  const { appWidget } = useAppWidgetQuery()
  const guaranteeAsset = useGuaranteeAssetQuery()
  const cameraBannerAsset = useCameraBannerAssetQuery()
  const guaranteeCopy = useGuaranteeCopyQuery()
  const quoteWizardAsset = useQuoteWizardAssetQuery()

  const appWidgetContent: AppWidgetData = appWidget.content

  return {
    expertReviewsData,
    videoButtonAssetData,
    expertSectionAssetData,
    affirmBannerData,
    appWidget: appWidgetContent,
    guaranteeAsset,
    cameraBannerAsset,
    guaranteeCopy,
    quoteWizardAsset
  }
}
